import './DefaultLayout.scss'

import {Component} from 'react'
import Helmet from 'react-helmet'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import Footer from '../Footer/Footer.jsx'
import Navbar from '../Navbar/Navbar.jsx'
import conf from '../../conf.js'
import sharedConf from '../../../shared/conf.js'
import ConnectedMenu, {FOR_DESKTOP, FOR_MOBILE} from "../ConnectedMenu/ConnectedMenu.jsx"

const SITE_URL = conf.site.url.full

class DefaultLayout extends Component {
  static propTypes = {
    className: PropTypes.string,
    helmet: PropTypes.object,
    id: PropTypes.string,
    navbar: PropTypes.element,
    navbarContained: PropTypes.bool,
    navbarSearch: PropTypes.bool,
    prerenderManaged: PropTypes.bool,
    showSidebarMenu: PropTypes.bool,
    showStickyPhone: PropTypes.bool,
  }

  static defaultProps = {
    className: '',
    helmet: {title: '', description: ''},
    id: null,
    prerenderManaged: false,
    showSidebarMenu: true,
    showStickyPhone: true,
    navbar: null,
    navbarContained: true,
    navbarFixed: true,
    navbarForceAccountType: sharedConf.accountTypes.freelance,
    navbarLocked: true,
    navbarSearch: true,
  }

  constructor(props) {
    super(props)

    this.state = {
      isCompany: false,
    }
  }

  componentDidMount() {
    if (!this.props.prerenderManaged) {
      window.prerenderReady = true
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (prevProps.user && this.props.user && prevProps.user.id !== this.props.user.id) {
      this.setState({
        isCompany: !(this.props.user && this.props.user.account_type === sharedConf.accountTypes.freelance)
      })
    }
  }

  render() {
    const {helmet, mobilefreelanceMenu = false} = this.props

    const title = "Twineeds | Consultants Ingénierie, Achats, Supply, Finance"
    const description = "Twineeds connecte entreprises et consultants indépendants en ingénierie, achats, supply, finance ou RH, avec un haut niveau d'expertise pour chaque mission."
    const defaultImage = `${SITE_URL}/static/images/twineeds_1200_630.png`

    const ogImage = helmet.image
      ? (helmet.image.startsWith('http') ? helmet.image : `${SITE_URL}${helmet.image}`)
      : defaultImage
    const ogUrl = helmet.url ? `${SITE_URL}${helmet.url}` : SITE_URL

    return (
      <div id={this.props.id} className={`default-layout ${this.props.className}`}>
        <Helmet>
          <title>{helmet.title || title}</title>
          <meta name="description" content={helmet.description || description}/>
          <meta property="og:title" content={helmet.title || title}/>
          <meta property="og:description" content={helmet.description || description}/>
          <meta property="og:image" content={ogImage}/>
          <meta property="og:url" content={ogUrl}/>
          <meta property="og:type" content={helmet.type || 'website'}/>
          <meta property="og:site_name" content="Twineeds"/>
          <meta name="twitter:card" content="summary_large_image"/>
          <meta property="twitter:title" content={helmet.title || title}/>
          <meta property="twitter:description" content={helmet.description || description}/>
          <meta property="twitter:image" content={ogImage}/>
        </Helmet>

        {this.props.navbar ?
          this.props.navbar :
          <Navbar
            contained={this.props.navbarContained}
            fixed={!!this.props.user}
            forceAccountType={this.state.isCompany ? sharedConf.accountTypes.do : sharedConf.accountTypes.freelance}
            locked={!this.props.user}
            search={this.props.navbarSearch}
          />
        }
        {this.props.user && this.props.showSidebarMenu !== false && (
          <ConnectedMenu user={this.props.user} isFor={FOR_MOBILE} mobilefreelanceMenu={mobilefreelanceMenu}/>
        )}
        <div id="layout-content-wrapper" style={{display: "flex"}}>
          {this.props.user && this.props.showSidebarMenu !== false && (<ConnectedMenu user={this.props.user}  isFor={FOR_DESKTOP}/>)}
          <div className="layout-content" style={{flex: "auto"}}>
            {this.props.children}
          </div>
        </div>
        <Footer/>

        {this.props.showStickyPhone && (
          <a href={`tel:${conf.site.phone}`} className="btn btn-primary sticky-phone d-none d-lg-block position-fixed">
            Contactez-nous au {conf.site.phone}
          </a>
        )}
      </div>
    )
  }
}

export default connect(
  (state) => ({
    user: state.currentUser.user,
  })
)(DefaultLayout)
